// extracted by mini-css-extract-plugin
export default {"container":"zr-z","brandName":"Ar-z","productName":"Br-z","productNamePdpEnhancements":"Cr-z","breakLongProductName":"Dr-z"};